/* eslint-disable no-nested-ternary */
import { Flex, Spacer } from '@kanvas/andromeda';
import { ActivityIndicator, TouchableOpacity } from 'react-native';
import { Button1, Button2 } from 'components/molecules/text';
import { IS_WEB } from 'domain/shared/constants';
import React, { useMemo } from 'react';
import { RectButtonProperties } from 'react-native-gesture-handler';
import styled from 'styled-components/native';
import colors from 'theme/colors';

interface IProps extends RectButtonProperties {
  icon?: React.ReactNode;
  text: string;
  loading?: boolean;
  height?:number;
  color?:string;
  textColor?:string;
  type?: 'button1' | 'button2';
  disabled?:boolean;
  paddingVertical?: number;
  maxWidth?: number;
}

const Container = styled(TouchableOpacity)<{ height?: number, color?: string, enabled: boolean, paddingVertical: number }>`
  justify-content: center;
  align-items: center;
  ${(props) => `height: ${props.height || 44}px`};
  border-radius: 8px;
  width: 100%;
  flex-direction: row;
  ${(props) => (props.enabled === false && 'opacity: 0.7')}
  background-color: ${(props) => props.color || colors.PRIMARY_DEEMPH};
  box-shadow: 0px -4px 16px ${colors.BUTTON_BORDER};
  padding-vertical: ${(props) => props.paddingVertical}px;
  ${IS_WEB ? `box-shadow: 0px -4px 16px ${colors.BUTTON_BORDER};` : ''};
`;

export const ChecklistButton = (props: IProps) => {
  const {
    text,
    loading = false,
    textColor,
    type = 'button2',
    enabled = true,
    paddingVertical = 12,
    ...rest
  } = props;

  const textProps = useMemo(() => ({ text, color: textColor || colors.ORANGE }), [text, textColor]);
  const changeTextProps = { text: "Change", color: textColor || colors.ORANGE }

  return (
    <Container disabled={enabled === false} {...rest} paddingVertical={paddingVertical}>
      {
        loading ? (
          <Flex>
            <ActivityIndicator size="small" color={colors.ORANGE} />
          </Flex>
        ) : (
          <Flex paddingHorizontal={16} style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            {type === 'button2' ? <Button2 {...textProps} /> : <Button1 {...textProps} />}
            {type === 'button2' ? <Button2 {...changeTextProps} /> : <Button1 {...changeTextProps} />}
          </Flex>
        )
      }
    </Container>
  );
};

export default ChecklistButton;
